module.exports = __webpack_public_path__ + "img/yoshi.a3e805c0.png";